import { render, staticRenderFns } from "./PreviewFileList.vue?vue&type=template&id=5bbb9d96&scoped=true&"
import script from "./PreviewFileList.vue?vue&type=script&lang=js&"
export * from "./PreviewFileList.vue?vue&type=script&lang=js&"
import style0 from "./PreviewFileList.vue?vue&type=style&index=0&id=5bbb9d96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbb9d96",
  null
  
)

export default component.exports